export default __webpack_public_path__ + "static/media/order_complete.91df2d32.png";